import React from 'react';
import '../styles/global.scss';
import Layout from '../components/Layout/Layout';
var Resume = function Resume() { return /*#__PURE__*/ React.createElement(React.Fragment, null, "Resume Page"); };
Resume.Layout = Layout;
export default Resume;
